import { ColDef, ColGroupDef } from "ag-grid-community";
import { ExcelDropdownReportRole } from "../../RolePanelTypes";
import { BasePermissionGrid } from "./BasePermissionGrid";

export class ExcelReportRoleGrid extends BasePermissionGrid<ExcelDropdownReportRole> {
    id: string = "ExcelDropdownReportRoles";
    gridClass: string = "permissionGrid";
    protected endpoint: string = "/rolePanel/excelDropdownReportRoles";
    protected getColumnDefs(): (ColDef<any, any> | ColGroupDef<any>)[] {
        return [
            { field: "Name", headerName: "Excel Report Name", flex: 3, resizable: false },
            {
                field: "AllowView",
                flex: 1,
                resizable: false,
                cellRendererParams: { disabled: false },
            },
        ];
    }
}
